<ng-container [formGroup]="formGroupCampaign">
  <div mdbInfiniteScroll #mdbInfiniteScroll
       style="max-width: 1660px; min-width: 830px; max-height: 600px; overflow-y: scroll">
    <div mdbSortableContainer class="sortable-list" (itemDrop)="onDrop($event,collection.found)">
      <div mdbDraggable *ngFor="let sponsor of collection.found;index as i" class="sortable-item" id="{{i}}">
        <div class="sponsor__drag-and-drop d-flex align-items-center justify-content-center">
          <app-icon-menu></app-icon-menu>
        </div>
        <div class="sponsor__content d-flex align-items-center">
          <div class="sponsor__number">{{i + 1}}.</div>
          <img [src]="getSponsorImageUrl(sponsor)" alt="thumbnail" class="sponsor__image">
          <div class="sponsor__container d-flex flex-column">
            <div class="sponsor__name mb-1">{{sponsor.name}}</div>
          </div>
          <div class="sponsor__actions">
            <div class="sponsor__action">
              <app-move-to [index]="sponsor.index" (onMoveTo)="moveTo($event)"></app-move-to>
            </div>
            <div class="sponsor__action" (click)="editSponsor(sponsor, sponsor.index)">
              <app-icon-pen [invalid]="collection.found[i].invalid"></app-icon-pen>
            </div>
            <div class="sponsor__action" (click)="removeSponsor(sponsor, sponsor.index)">
              <app-icon-trash [invalid]="collection.found[i].invalid"></app-icon-trash>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sponsor__empty" *ngIf="collection.found.length < 1">Click <b>Add</b> to start adding sponsor</div>
  </div>
  <div *ngIf="collection.found.length > 1" class="drag-and-drop d-flex align-items-center justify-content-center mt-3">
    Drag and drop sponsors to reorder or use Move.
  </div>
</ng-container>
